import { render, staticRenderFns } from "./BadCredit.vue?vue&type=template&id=314f7da0"
import script from "./BadCredit.vue?vue&type=script&lang=js"
export * from "./BadCredit.vue?vue&type=script&lang=js"
import style0 from "./BadCredit.vue?vue&type=style&index=0&id=314f7da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports